import React, { useEffect } from "react";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { GoogleLogin } from "@react-oauth/google";
import {  useLocation, useNavigate } from "react-router-dom";
import styles from "../layout/Layout.module.css";
import { APP_NAME, BaseURL, GOOGLE_CLIENT_ID } from "../../utils/appConstant";
import { ToastContainer, toast, Slide } from "react-toastify";
import { delete_user_data_from_client_side } from "../../utils/common";


function UserLogin() {
    const navigate = useNavigate();
    const location = useLocation();
    useEffect(() => {
        const logout = async () => {
            if (location.state !== null && location.state.logout) {
                await fetch(`${BaseURL}/logout`, {
                    method: "DELETE",
                    headers: {
                        "Content-Type": "application/json",
                        "Access-Control-Allow-Origin": "*",
                        "Access-Control-Allow-Methods": "GET, POST, OPTIONS, PUT, DELETE",
                        "Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept, Authorization"
                    }
                });
                navigate("/user_login", { state: { logout: undefined } });
                delete_user_data_from_client_side();
            }
        };
        logout();
    }, []);
    const notifyError = () => {
        toast.error("Login Failed!", {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            transition: Slide,
            style: { color: "rgb(30 41 59)" }
        });
    };

    return (
        <div className={`${styles.layout} w-full`}>
            <header className={`${styles.header} sticky top-0 z-50 w-full shadow-lg`} role={"banner"}>
                <div className={`${styles.headerContainer} h-16`}>
                    <h3 className={styles.headerTitle}>{APP_NAME} - Mentor</h3>
                    <div className={`${styles.headerRightText} flex items-center pl-2 mr-2  rounded-xl h-16`}>
                        <img src="/favicon.ico" className=" justify-self-end  h-16" />
                    </div>
                </div>
            </header>

            <div className="flex justify-center items-center h-full">
                <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
                    <GoogleLogin
                        onSuccess={credentialResponse => {
                            if (credentialResponse.credential) {
                                const token = credentialResponse.credential;

                                fetch(`${BaseURL}/google_login`, {
                                    method: "POST",
                                    headers: {
                                        "Content-Type": "application/json"
                                    },
                                    body: JSON.stringify({ code: credentialResponse.credential })
                                })
                                    .then(response => {
                                        if (!response.ok) {
                                            throw new Error("Login failed");
                                        }
                                        return response.json();
                                    })
                                    .then(data => {
                                        localStorage.setItem("user_data", JSON.stringify(data.user_data));
                                        document.cookie = `access_token_cookie=${data.access_token}; path=/; SameSite=None; Secure`;
                                        navigate("/workbench"); 
                                    })
                                    .catch(error => {
                                        notifyError();
                                        console.error("Login failed", error);
                                    });
                            } else {
                                console.error("Credential is undefined");
                            }
                        }}
                        onError={() => {
                            notifyError();
                            console.log("Login Failed");
                        }}
                        useOneTap={true}
                    />

                </GoogleOAuthProvider>
            </div>
            <ToastContainer />
        </div>
    );
}

export default UserLogin;
